export default "__VITE_ASSET__Bbhov0hr__"